<template>
<div class="view-content">
	  <div class="view-content-info">
		<div class="user-login">
		  	<div class="user-login-title"><a href="/">首页</a> / <span>资讯</span></div>
			<div class="news-list" v-if="list.length > 0">
				<router-link :to="'/newsinfo?id='+item.id" v-for="item in list" :key="item.id" class="news-item flex-start">
					<img class="item-image" :src="item.image"/>
					<div class="news-text">
						<div class="news-name">{{item.title}}</div>
						<div class="news-time">{{item.releaseTime}}</div>
						<div class="news-info">{{item.info}}</div>
					</div>
				</router-link>
			</div>
			<noData v-if="list.length == 0 && isLoad == true" msg="对不起，暂无资讯"></noData>
			
			<div class="page" v-if="total > 0">
			    <el-pagination @current-change="getPageList" :current-page="page" :page-size="limit" layout="total, prev, pager, next" :total="total"></el-pagination>
			</div>
		</div>
	  </div>
	</div>
</template>

<script>
import noData from '@/components/noData.vue'
import {getNewslist} from "@/api/index"
export default {
	name: 'index',
	components:{
		noData
	},
	data(){
		return {
			list:[],
			page:1,
			limit:5,
			total:0,
			isLoad:false
		}
	},
	mounted() {
		this.isLoad = false;
		this.getList();
	},
	methods:{
		getList(){
			getNewslist({page:this.page,size:this.limit}).then(res=>{
				if(res.code == 1000){
					this.list = res.data.list;
					this.total = res.data.total;
					this.isLoad = true;
				}else{
					return this.$message.error(res.message);
				}
			})
		},
		getPageList(e){
			this.isLoad = false;
			this.page = e;
			this.getList();
		}
	}
}
</script>

<style lang="scss" scoped>
	.news-list{
		min-height: 80vh;
		.news-item{
			width: 100%;
			background-color: #fff;
			margin-bottom: 20px;
			.item-image{
				width: 320px;
				height: 240px;
				object-fit: cover;
				flex: 0 0 320px;
			}
			.news-text{
				padding: 20px 30px;
				width: 100%;
				.news-name{
					font-size: 24px;
					font-weight: 500;
					color: #070B13;
				}
				.news-time{
					opacity: 0.6;
					font-size: 16px;
					color: #070B13;
					margin-top: 20px;
				}
				.news-info{
					opacity: 0.6;
					font-size: 16px;
					color: #070B13;
					margin-top: 20px;
				}
			}
		}
	}
</style>
